import React from 'react';
import ReactDOM from 'react-dom';

import { LightDoubleArrowLeftSvg } from '@dndbeyond/character-components/es';

import { SidebarInfo } from '../../typings';

interface Props {
    sidebarInfo: SidebarInfo;
    onChange?: (id: string) => void;
    onMaskClick?: () => void;
    onSidebarClick?: () => void;
    closeOnMaskClick: boolean;
}
interface State {
    isOpen: boolean;
}
export default class QuickNav extends React.PureComponent<Props, State> {
    static defaultProps = {
        closeOnMaskClick: true,
    };

    portal: Element = document.createElement('div');

    constructor(props) {
        super(props);

        this.portal.classList.add('ct-quick-nav__portal');

        this.state = {
            isOpen: false,
        };
    }

    componentDidMount() {
        document.body.appendChild(this.portal);
    }

    componentWillUnmount() {
        document.body.removeChild(this.portal);
    }

    handleChange = (id: string): void => {
        const { onChange } = this.props;

        if (onChange) {
            onChange(id);
            this.handleClose();
        }
    };

    handleMaskClick = (evt: React.MouseEvent): void => {
        const { onMaskClick, closeOnMaskClick } = this.props;

        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();

        if (onMaskClick) {
            onMaskClick();
        }

        if (closeOnMaskClick) {
            this.handleClose();
        }
    };

    handleClose = (): void => {
        this.setState({
            isOpen: false,
        });
    };

    handleToggleClick = (evt: React.MouseEvent): void => {
        this.setState((prevState) => ({
            isOpen: !prevState.isOpen,
        }));
    };

    handleSidebarClick = (evt: React.MouseEvent): void => {
        const { isOpen } = this.state;
        const { onSidebarClick } = this.props;

        if (isOpen) {
            return;
        }

        if (onSidebarClick) {
            onSidebarClick();
            this.handleClose();
        }
    };

    renderMenu = (): React.ReactNode => {
        const { isOpen } = this.state;
        const { children, sidebarInfo } = this.props;

        if (!isOpen || sidebarInfo.isVisible) {
            return null;
        }

        //TODO refactor this to get around issues with typing
        return (
            <div className="ct-quick-nav__menu">
                <div className="ct-quick-nav__menu-items">
                    {React.Children.toArray(children).map((child: any) => {
                        return React.cloneElement(child, {
                            key: child.props.id,
                            onChange: this.handleChange.bind(this, child.props.id),
                            ...child.props,
                        });
                    })}
                </div>
            </div>
        );
    };

    renderToggle = (): React.ReactNode => {
        const { isOpen } = this.state;
        const { sidebarInfo } = this.props;

        if (sidebarInfo.isVisible) {
            return null;
        }

        let classNames: Array<string> = ['ct-quick-nav__toggle'];
        if (isOpen) {
            classNames.push('ct-quick-nav__toggle--opened');
        } else {
            classNames.push('ct-quick-nav__toggle--closed');
        }

        return <div className={classNames.join(' ')} onClick={this.handleToggleClick} />;
    };

    renderSidebar = (): React.ReactNode => {
        const { isOpen } = this.state;
        const { sidebarInfo } = this.props;

        let classNames: Array<string> = ['ct-quick-nav__edge-toggle'];
        if (sidebarInfo.isVisible) {
            classNames.push('ct-quick-nav__edge-toggle--visible');
        } else {
            classNames.push('ct-quick-nav__edge-toggle--not-visible');
        }
        if (isOpen) {
            classNames.push('ct-quick-nav__edge-toggle--opened');
        } else {
            classNames.push('ct-quick-nav__edge-toggle--closed');
        }

        return (
            <div className={classNames.join(' ')} onClick={this.handleSidebarClick}>
                <LightDoubleArrowLeftSvg />
            </div>
        );
    };

    renderPortal = (): React.ReactNode => {
        const { isOpen } = this.state;

        let classNames: Array<string> = ['ct-quick-nav'];
        if (isOpen) {
            classNames.push('ct-quick-nav--opened');
        } else {
            classNames.push('ct-quick-nav--closed');
        }

        return (
            <div className={classNames.join(' ')}>
                <div className="ct-quick-nav__mask" onClick={this.handleMaskClick} />
                <div className="ct-quick-nav__content">
                    {this.renderMenu()}
                    <div className="ct-quick-nav__footer">
                        <div className="ct-quick-nav__footer-toggle">{this.renderToggle()}</div>
                        <div className="ct-quick-nav__footer-sidebar">{this.renderSidebar()}</div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        return ReactDOM.createPortal(this.renderPortal(), this.portal);
    }
}
